import { connect } from 'react-redux'
import { Route } from 'react-router-dom'
import React from 'react'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import MobilePaymentContainer from './MobilePaymentContainer'
import internalModule, { init } from './modules'

const Component = connect(
  (state) => ({
    payPageMainMobileMobilePaymentContainerState: state.payPageMainMobileMobilePaymentContainerState,
    siteConfig: state.siteConfig,
  }),
  {
    init,
  }
)(MobilePaymentContainer)
export default function(route) {
  return (
    <Route
      path={`${route.match.path}`}
      render={(routeProps) => (
        <DynamicModuleLoader modules={[internalModule(routeProps.history)]}>
          <Component {...route} {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
